import Text from '@zenbusiness/common-components/Text';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Skeleton from '#client/components/Skeleton';

import useStyles from './useStyles';

const OptOutMessaging = ({ isOptedOut, onClickOptOut }) => {
  const classes = useStyles();

  if (isOptedOut) {
    return (
      <Grid item xs={12} sm={10} md={6}>
        <Typography variant="h4" component="h3" className={classes.boldText}>
          You’re opted out of our partner program
        </Typography>
        <Text size="sm">
          We won’t share your information with any of our partners. You can opt back in,
          via choosing an offer from our partners, at any&nbsp;time.
        </Text>
      </Grid>
    );
  }

  return (
    <>
      <Grid item xs={12} sm={9}>
        <Text size="sm">
          We only work with companies we know and trust to provide valuable small business
          services for our customers. But you can always opt out if you don’t want to
          connect with our partners.
        </Text>
      </Grid>
      <Grid item xs={12} sm className={classes.optOutButtonContainer}>
        <Button
          size="medium"
          variant="secondary"
          color="Focus"
          onClick={onClickOptOut}
        >
          Opt out
        </Button>
      </Grid>
    </>
  );
};

OptOutMessaging.propTypes = {
  isOptedOut: PropTypes.bool.isRequired,
  onClickOptOut: PropTypes.func.isRequired
};

const ConnectWithPartners = ({
  account: {
    allPartnerOptOut: isOptedOut
  } = {},
  onClickOptOut,
  loading
}) => {
  const classes = useStyles();

  return (
    <section className={classes.card}>
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
      >
        <Grid item xs>
          <Typography className={classes.boldText} variant="h4" component="h2">
            Connect with our partners
          </Typography>
        </Grid>
      </Grid>
      <Divider className={classes.divider} aria-hidden />
      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={2}
        className={classes.row}
      >
        {loading
          ? <Skeleton height="64px" width="50%" />
          : (
            <OptOutMessaging
              isOptedOut={isOptedOut}
              onClickOptOut={onClickOptOut}
            />
          )}
      </Grid>
    </section>
  );
};

ConnectWithPartners.propTypes = {
  account: PropTypes.shape({}).isRequired,
  onClickOptOut: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ConnectWithPartners;
